import {
  CharlieDialog,
  CharlieDialogContent,
  CharlieButton,
} from '@ver.id/libs.ui.charlie';
import { useTranslation } from '../../i18n/i18n';
import HostedInstallInstructions from './InstallInstructions';

/**
 * HostedInstallInstructionsModal — App install instructions with QR + store badges.
 *
 * Figma screens:
 *   Desktop available (Journey 5):     https://www.figma.com/design/6V1D3oNy17pfFNHIRb2nmm/Ronan-V2---UX?node-id=73-9175
 *   Desktop unavailable (Journey 5):   https://www.figma.com/design/6V1D3oNy17pfFNHIRb2nmm/Ronan-V2---UX?node-id=73-9250
 *   Mobile available (Journey 5):      https://www.figma.com/design/6V1D3oNy17pfFNHIRb2nmm/Ronan-V2---UX?node-id=208-52997
 *   Mobile unavailable (Journey 5):    https://www.figma.com/design/6V1D3oNy17pfFNHIRb2nmm/Ronan-V2---UX?node-id=208-53241
 */

type Props = {
  open: boolean;
  appName?: string;
  appNameWithArticle?: string;
  onClose: () => void;
};

export default function HostedInstallInstructionsModal({
  open,
  appName,
  appNameWithArticle,
  onClose,
}: Props) {
  const { t } = useTranslation();

  if (!open) return null;

  const displayName = appNameWithArticle || appName || 'your identity app';

  return (
    <CharlieDialog
      open
      onOpenChange={(o) => {
        if (!o) onClose();
      }}
    >
      <CharlieDialogContent>
        <HostedInstallInstructions
          appName={appName}
          displayName={displayName}
        />

        <CharlieButton variant="outline" pill block onClick={onClose}>
          {t('installInstructions.close')}
        </CharlieButton>
      </CharlieDialogContent>
    </CharlieDialog>
  );
}
